import React from 'react'
import Container from '../foundations/Container'
import Action from '../primitives/Action'
import styles from './TVRentalChooser.module.scss'

const TVRentalChooser = () => (
  <section className={styles.section} aria-label='Choose a TV rental path'>
    <Container>
      <div className={styles.panel}>
        <p><strong>Start with a complete display bundle.</strong> Choose an audience display, portrait display, touchscreen or presenter confidence monitor. Each product lists its own included equipment and fulfillment options.</p>
        <nav className={styles.links} aria-label='Other TV rental options'>
          <Action href='#individual-displays' variant='quiet' size='compact'>Individual displays</Action>
          <Action href='#tv-accessories' variant='quiet' size='compact'>TV accessories</Action>
          <Action href='#tv-setup-guide' variant='quiet' size='compact'>Setup checklist</Action>
        </nav>
      </div>
    </Container>
  </section>
)

export default TVRentalChooser
